"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
function Title({ text }) {
    return React.createElement("h1", { className: "Title" }, text);
}
exports.Title = Title;
exports.default = Title;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-title/Title.tsx